import { dropDown } from 'public/dropdown.js'
// import { itemLinkCheck } from 'public/repeater.js'
import editorAnimation, { stam } from 'public/editorAnimation.js'
import { formFactor } from 'wix-window';
import { local } from 'wix-storage';
import wixAnimations from 'wix-animations';
import wixLocation from 'wix-location';
import { fireBIEvent } from 'public/bi-events.js';

const currentTab = 'Design & Layouting';

$w.onReady(function () {
    local.setItem('currentSection', 'Design & Layouting');
    local.setItem('isEndOfThePage', 'false');
    local.setItem('isScrolldown', 'false');
    fireBiEventOnElements();
    // itemLinkCheck();
    $w('#dropBtn').onClick(() => {
        dropDown();
    });

    editorAnimation();
    seeMoreFeatures();
    backToTop();
    // clickLink();
    banner();

});

function seeMoreFeatures() {
    if (formFactor === 'Tablet' || formFactor === 'Mobile') {
        $w('#featuresRepeater').forEachItem(($item, itemData, index) => {
            if (index > 3) $item('#featureItem').collapse();
        })
    }

    $w('#seeAllBtn').onClick(() => {
        $w('#featuresRepeater').forEachItem(($item, itemData, index) => {
            $item('#featureItem').expand();
        });

        $w('#seeAllSection').collapse();

    })

}

function backToTop() {
    $w('#backToTrigger').onViewportEnter(() => {
        $w('#backToTop').hide('fade', { duration: 150 })
    });

    $w('#backToTrigger').onViewportLeave(() => {
        $w('#backToTop').show('fade', { duration: 150 })
    })
}

function banner() {

    let bannerBox = $w('#bannerBox01');

    let move = 1455;

    let bannerTimeline = wixAnimations.timeline({ repeat: -1 }).add(bannerBox, { x: move, duration: 10000, easing: 'easeLinear' })

    bannerTimeline.play();

    bannerBox.onMouseIn(() => {
        bannerTimeline.pause();
    });

    bannerBox.onMouseOut(() => {
        bannerTimeline.play();
    })

}

const fireBiEventOnElements = () => {
    $w('#box1240').onClick(() => {
        const biFields = {
            tab_name: currentTab,
            cta_loc: 'top'
        }
        fireBIEvent(110, 2401, biFields);
    });
    $w('#box52').onClick(() => {
        const biFields = {
            tab_name: currentTab,
            cta_loc: 'grid'
        }
        fireBIEvent(110, 2401, biFields);
    });
    $w('#interactionsLink').onClick(() => {
        local.setItem('currentSection', 'Interactions & Effects');
        local.setItem('isEndOfThePage', 'false');
        local.setItem('isScrolldown', 'false');
        const biFields = {
            tab_name: 'Interactions & Effects'
        }
        fireBIEvent(110, 2400, biFields);
        wixLocation.to('/interactions-effects');
    });
    $w('#designedAssetsLink').onClick(() => {
        local.setItem('currentSection', 'Designed Assets & Media');
        local.setItem('isEndOfThePage', 'false');
        local.setItem('isScrolldown', 'false');
        const biFields = {
            tab_name: 'Designed Assets & Media'
        }
        fireBIEvent(110, 2400, biFields);
        wixLocation.to('/assets-media');
    });
    $w('#bannerBox01').onClick(() => {

        const biFields = {
            tab_name: currentTab
        }
        fireBIEvent(110, 2403, biFields);
    });
    $w('#text107').onViewportLeave(() => {
        const biFields = {
            tab_name: currentTab
        }
        const isScrollDown = local.getItem('isScrolldown') === 'true';
        !isScrollDown && fireBIEvent(110, 2405, biFields);
        local.setItem('isScrolldown', 'true');

    });
    $w('#box5').onClick(() => {
        const biFields = {
            button_name: 'Learn more',
            cta_loc: 'top',
            lesson_category: 'Editor X Essentials',
            lesson_name: 'Breakpoints part 1',
            tab_name: currentTab,
        }
        fireBIEvent(110, 2402, biFields);
    });

    $w('#box15').onClick(() => {
        const biFields = {
            button_name: 'View lesson',
            cta_loc: 'grid',
            lesson_category: 'Editor X Essentials',
            lesson_name: 'CSS grid',
            tab_name: currentTab,
        }
        fireBIEvent(110, 2402, biFields);
    });
    $w('#box18').onClick(() => {
        const biFields = {
            button_name: 'View lesson',
            cta_loc: 'grid',
            lesson_category: 'Design & Layouting',
            lesson_name: 'Repeaters',
            tab_name: currentTab,
        }
        fireBIEvent(110, 2402, biFields);
    });
    $w('#box24').onClick(() => {
        const biFields = {
            button_name: 'View lesson',
            cta_loc: 'grid',
            lesson_category: 'Design & Layouting',
            lesson_name: 'Layouter',
            tab_name: currentTab,
        }
        fireBIEvent(110, 2402, biFields);
    });
    $w('#box30').onClick(() => {
        const biFields = {
            button_name: 'View lesson',
            cta_loc: 'grid',
            lesson_category: 'Design & Layouting',
            lesson_name: 'Docking & margins',
            tab_name: currentTab,
        }
        fireBIEvent(110, 2402, biFields);
    });
    $w("#repeater5").forEachItem(($item, itemData, index) => {
        $item('#box132').onClick(() => {
            const lessonName = $item('#text94').text;
            const biFields = {
                button_name: 'Learn more',
                cta_loc: 'grid',
                lesson_category: 'Design & Layouting',
                lesson_name: lessonName,
                tab_name: currentTab,
            }
            fireBIEvent(110, 2402, biFields);
        });
    });

}